var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "whatsapp-message-preview" }, [
    _c("div", { staticClass: "heading" }, [_vm._v("Preview")]),
    _vm._v(" "),
    _c("div", { staticClass: "custom-whatsapp-message" }, [
      _c(
        "div",
        { staticClass: "content-wrapper" },
        [
          _vm.templateType !== "CAROUSEL" &&
          ["IMAGE", "VIDEO", "DOCUMENT"].includes(_vm.headerMediaType)
            ? [
                !_vm.headerMediaURL
                  ? [
                      _c("img", {
                        attrs: {
                          width: "100%",
                          src: _vm.getDefaultImage(_vm.headerMediaType),
                          alt: "''",
                        },
                      }),
                    ]
                  : _vm.headerMediaType === "DOCUMENT"
                  ? _c("div", [
                      _c("embed", {
                        attrs: {
                          src: _vm.headerMediaURL,
                          width: "100%",
                          type: "application/pdf",
                        },
                      }),
                    ])
                  : _vm.headerMediaType === "VIDEO"
                  ? _c("div", [
                      _c("video", {
                        attrs: {
                          width: "100%",
                          src: _vm.headerMediaURL,
                          controls: "",
                        },
                      }),
                    ])
                  : _vm.headerMediaType === "IMAGE"
                  ? _c("div", [
                      _c("img", {
                        attrs: {
                          width: "100%",
                          src: _vm.headerMediaURL,
                          alt: "",
                        },
                      }),
                    ])
                  : _vm._e(),
              ]
            : _vm.headerText
            ? _c("div", { staticClass: "header-text" }, [
                _vm._v(_vm._s(_vm.headerText)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "body" }, [_vm._v(_vm._s(_vm.body))]),
          _vm._v(" "),
          _vm.footer
            ? _c("div", { staticClass: "footer" }, [_vm._v(_vm._s(_vm.footer))])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "timestamp" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$moment().format("HH:mm")) +
                "\n            "
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm.buttons
        ? _c(
            "div",
            { staticClass: "buttons" },
            [
              _vm._l(
                _vm.buttons.slice(0, _vm.buttons.length > 3 ? 2 : 3),
                function (button, index) {
                  return [
                    index < 3
                      ? [
                          button.type === "URL"
                            ? _c("div", { staticClass: "button url" }, [
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v("open_in_new"),
                                ]),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(button.text) +
                                    "\n                    "
                                ),
                              ])
                            : button.type === "PHONE_NUMBER"
                            ? _c("div", { staticClass: "button url" }, [
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v("call"),
                                ]),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(button.text) +
                                    "\n                    "
                                ),
                              ])
                            : _c("div", { staticClass: "button quick-reply" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(button.text) +
                                    "\n                    "
                                ),
                              ]),
                        ]
                      : _vm._e(),
                  ]
                }
              ),
              _vm._v(" "),
              _vm.buttons.length > 3
                ? _c("div", { staticClass: "button" }, [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("list"),
                    ]),
                    _vm._v("\n                See all options\n            "),
                  ])
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.templateType === "CAROUSEL"
      ? _c(
          "div",
          { staticClass: "carousel-whatsapp-message" },
          _vm._l(_vm.cards, function (card) {
            return _c(
              "div",
              { staticClass: "carousel-whatsapp-message-item" },
              [
                _c(
                  "div",
                  { staticClass: "content-wrapper" },
                  [
                    !card.mediaUrl
                      ? [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              src: _vm.getDefaultImage(card.headerType),
                              alt: "''",
                            },
                          }),
                        ]
                      : [
                          card.headerType === "VIDEO"
                            ? _c("div", [
                                _c("video", {
                                  attrs: {
                                    width: "100%",
                                    src: card.mediaUrl,
                                    controls: "",
                                  },
                                }),
                              ])
                            : card.headerType === "IMAGE"
                            ? _c("div", [
                                _c("img", {
                                  attrs: {
                                    width: "100%",
                                    src: card.mediaUrl,
                                    alt: "",
                                  },
                                }),
                              ])
                            : card.headerType === "DOCUMENT"
                            ? _c("div", [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getDefaultImage(),
                                    alt: "''",
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ],
                    _vm._v(" "),
                    _c("div", { staticClass: "body" }, [
                      _vm._v(_vm._s(card.sampleText)),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                card.buttons
                  ? _c(
                      "div",
                      { staticClass: "buttons" },
                      [
                        _vm._l(card.buttons, function (button) {
                          return [
                            button.type === "URL"
                              ? _c("div", { staticClass: "button url" }, [
                                  _c("div", { staticClass: "material-icons" }, [
                                    _vm._v("open_in_new"),
                                  ]),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(button.text) +
                                      "\n                    "
                                  ),
                                ])
                              : _c(
                                  "div",
                                  { staticClass: "button quick-reply" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(button.text) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                          ]
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }